'use client';

import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Link from 'next/link';
import { authApi } from '@/lib/api';

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check if already logged in
    const token = localStorage.getItem('amam_token');
    if (token) {
      router.push('/menu');
    }
  }, [router]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authApi.login(email, password);
      const { access_token, user } = response.data;

      // Store token and user info
      localStorage.setItem('amam_token', access_token);
      localStorage.setItem('amam_user', JSON.stringify(user));

      // Redirect to menu
      router.push('/menu');
    } catch (err: any) {
      setError(err.response?.data?.message || 'התחברות נכשלה. אנא נסה שוב.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-primary-900 text-white py-4">
        <div className="container mx-auto px-4">
          <Link href="/" className="text-2xl font-bold">
            AmAm
          </Link>
        </div>
      </header>

      {/* Login Form */}
      <div className="container mx-auto px-4 py-12 max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-center mb-6">התחברות</h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                אימייל
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                required
                placeholder="your@email.com"
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-2">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                  סיסמה
                </label>
                <Link
                  href="/forgot-password"
                  className="text-sm text-primary-900 hover:underline"
                >
                  שכחת סיסמה?
                </Link>
              </div>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                required
                placeholder="הכנס סיסמה"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-primary-900 text-white py-3 px-4 rounded-lg font-medium hover:bg-primary-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'מתחבר...' : 'התחברות'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              אין לך חשבון?{' '}
              <Link href="/register" className="text-primary-900 font-medium hover:underline">
                הירשם כאן
              </Link>
            </p>
          </div>

          <div className="mt-4 text-center">
            <Link href="/menu" className="text-sm text-gray-500 hover:text-gray-700">
              המשך כאורח →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
